import moment, { Moment } from "moment-timezone";
import ApiDateParser from "../../helpers/parsers/apiDateParser";
import { Hash } from "../@types/apiTypes";
import BaseModel from "./BaseModel";
import CandidateModel from "./CandidateModel";
import SessionModel from "./SessionModel";
import StudentModel from "./StudentModel";

export enum SlotStates {
  "done",
  "in_progress",
  "upcoming",
  "not_started",
  "reservable",
  "locked",
  "available",
  "booked",
  "fake",
  "canceled",
  "absence",
  "disconnected",
  "disconnected_by_system",
  "terminated_early",
  "tutor_absence",
  "canceled_by_student",
  "student_absence",
  "canceled_by_tutor",
}
export default class ScheduleSlotModel extends BaseModel {
  startTime: Moment;
  endTime: Moment;
  date?: Moment;
  dayOfWeek: string;
  student?: StudentModel | CandidateModel;
  session?: SessionModel;
  id: number;
  sessionNumber?: number;
  private __isCanceled?: boolean;

  constructor(arg: any) {
    super(arg);
    this.startTime = ApiDateParser.parse(arg.start_time);
    this.endTime = ApiDateParser.parse(arg.end_time);
    this.date = ApiDateParser.parse(arg.date);
    this.id = arg.id;
    this.sessionNumber = arg?.sessionNumber;
    this.dayOfWeek = arg.day_of_the_week;
    this.__isCanceled = arg.is_canceled;
    if (!!arg.student) this.student = StudentModel.fromApiResponse(arg.student);
    if (!!arg.candidate)
      this.student = CandidateModel.fromApiResponse(arg.candidate);
    if (!!arg.session) this.session = SessionModel.fromApiResponse(arg.session);
  }

  get isCanceled() {
    return !!this.__isCanceled;
  }

  get isReserved() {
    return !!this.student;
  }

  get state(): SlotStates {
    if (this.isCanceled) return SlotStates.canceled;
    if (!this.isReserved) return SlotStates.reservable;
    if (!!this.session) {
      /**
       * At the beginning of implementing this model, we assumed that the session related to the slot will be returned with it from the backend
       * So, we calculate here the state of the slot based on the session state.
       * Now, the session isn't being returned from the backend with the slots,
       * so we calculate the state based on start and end time in the CalendarScheduleSlotModel
       * However, I will keep this logic here as we may need it in the future
       */
      if (this.session.isInProgress) return SlotStates.in_progress;
      return SlotStates.done;
    }
    if (this.startTime.diff(moment(), "minutes") < 15)
      return SlotStates.upcoming;
    return SlotStates.not_started;
  }

  static fromDaySlotsApiResponse(arg: Hash<any>[]): ScheduleSlotModel[] {
    const slots = arg.map((slot) => {
      return new ScheduleSlotModel({
        ...slot.schedule_slot,
        student: slot.student,
        sessionNumber: slot?.session_number,
        candidate: slot.candidate,
      });
    });
    return slots;
  }
}
